import { gql } from '@src/lib/gql'

export const ADVISOR_APPLY_USER_PROFILE = gql`
  query AdvisorApplyUserProfile {
    viewer {
      currentUser {
        id
        userId
        shortBio
        userSkills(order: [["experienceStrength", "desc"]]) {
          id
          userSkillId
          skillId
          title
          userRoleKeys
          compensationTypeKeys
          deletedAt
          skill {
            id
            skillId
            title
          }
        }
        userExperiences {
          id
          userExperienceId
          experienceTypeKey
          organizationName
          positionDescription
          positionTitle
        }
      }
    }
  }
`
